import { CONTENT_SECTIONS } from '../sections';
import { INSURANCE_TYPES } from '../../constants';
import type { ContentData } from './types';

const data: ContentData = {
  sections: [
    {
      type: CONTENT_SECTIONS.POPULAR_DESTINATIONS,
    },
  ],
  type: INSURANCE_TYPES.TRAVEL,
};

export default data;
